import { render } from "./CheEseburger.vue?vue&type=template&id=6cdeb0a3"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CheEseburger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cdeb0a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cdeb0a3', __exports__)) {
    api.reload('6cdeb0a3', __exports__)
  }
  
  module.hot.accept("./CheEseburger.vue?vue&type=template&id=6cdeb0a3", () => {
    api.rerender('6cdeb0a3', render)
  })

}


export default __exports__